<template>
  <log-list
    :isLoading="isLoading"
    :list="dataPayment"
    :Model="getModel"
    :maxPreviewCount="4"
    @onCreate="handleCreate"
    @onViewAll="handleViewAll"
  />
</template>

<script>
import { ModelPaymentLog, ServicePayments } from '@/services/Payments'

export default {
  name: 'PaymentLog',
  components: {
    'log-list': () => import(/* webpackChunkName: 'LogList' */ '@/components/LogList')
  },
  props: {
    paymentID: {
      required: true
    }
  },
  created () {
    this.$bus.$on('on-update-log', this.loadPayments)
  },
  beforeDestroy () {
    this.$bus.$off('on-update-log', this.loadPayments)
  },
  watch: {
    paymentID (value) {
      if (value) {
        this.loadPayments()
      } else {
        this.dataPayment = []
      }
    }
  },
  data () {
    return {
      dataPayment: [],
      isLoading: false
    }
  },
  methods: {
    getModel () {
      return new ModelPaymentLog()
    },
    handleViewAll () {
      this.loadPayments({ isGetAll: true })
    },
    async loadPayments ({ isGetAll = false } = {}) {
      if (!this.paymentID) {
        return
      }
      this.isLoading = true
      try {
        const { data } = await ServicePayments.getAllDynamicLogs({
          select: 'id,paymentID,employeeID,entryDate,description,isEmployeeEntry,isRead',
          filter: `paymentID == ${this.paymentID}`,
          take: isGetAll ? undefined : 4
        })
        this.dataPayment = data.value
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    },
    async handleCreate (data) {
      this.isLoading = true
      try {
        const { data: createdData } = await ServicePayments.createLog({ ...data, paymentID: this.paymentID })
        this.dataPayment = [createdData, ...this.dataPayment]
        this.isLoading = true
      } catch (e) {
        this.requestErrorHandler(e)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
